import React from 'react';
import { useTranslation } from 'react-i18next';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import DownloadIcon from '@mui/icons-material/Download';
import { Box, Stack } from '@mui/material';
// own
import IconButton from '../../../../../../../../../../IconButton';
import { createSx } from '../../../../../../../../../../../utils';
import ButtonGroupWrapper from '../../../../../../../../../../IconButton/ButtonGroupWrapper';

const sx = createSx({
  root: {
    position: 'absolute',
    width: '100%',
    bottom: 16,
    display: 'flex',
    justifyContent: 'center'
  }
});

interface Props {
  handleZoomIn: () => void;
  handleZoomOut: () => void;
  handleRotateLeft: () => void;
  handleRotateRight: () => void;
  downloadUrl?: string;
  attachmentName: string;
}

const Footer = ({
  handleZoomIn,
  handleZoomOut,
  handleRotateLeft,
  handleRotateRight,
  downloadUrl,
  attachmentName
}: Props) => {
  const { t } = useTranslation();

  return (
    <Box sx={sx.root}>
      <Stack direction='row' spacing={3}>
        <ButtonGroupWrapper>
          <IconButton
            title={t('label_zoomIn')}
            onClick={handleZoomIn}
            testID='zoom-in-button'
          >
            <ZoomInIcon />
          </IconButton>
          <IconButton
            title={t('label_zoomOut')}
            onClick={handleZoomOut}
            testID='zoom-out-button'
          >
            <ZoomOutIcon />
          </IconButton>
        </ButtonGroupWrapper>
        <ButtonGroupWrapper>
          <IconButton
            title={t('label_rotateLeft')}
            onClick={handleRotateLeft}
            testID='rotate-left-button'
          >
            <RotateLeftIcon />
          </IconButton>
          <IconButton
            title={t('label_rotateRight')}
            onClick={handleRotateRight}
            testID='rotate-right-button'
          >
            <RotateRightIcon />
          </IconButton>
        </ButtonGroupWrapper>
        {downloadUrl && <ButtonGroupWrapper>
          <a
            href={downloadUrl}
            target='_blank'
            download={attachmentName}
            data-test-id='download-button'
          >
            <IconButton title={t('download')}>
              <DownloadIcon />
            </IconButton>
          </a>
        </ButtonGroupWrapper>}
      </Stack>
    </Box>
  );
};

export default Footer;